export default {
    nl: {
        intro: {
            subtitle: 'Intranet',
            title: 'Je eigen internet.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/intranet/hero.jpg',
        },
        type: 'Intranet',
        title: 'Intranet: de digitale hub voor communicatie en teamwork',
        description:
            'Intranet stimuleert samenwerking en kennisdeling. Verrijk bedrijfscultuur en efficiëntie met tools voor communicatie en projectbeheer.',
        content: [
            {
                type: 'text',
                title: 'Intranet',
                content:
                    'In de digitale wereld is tegenwoordig alles binnen handbereik. Het intranet zorgt ervoor dat medewerkers altijd en overal verbonden blijven. Maar het gaat niet alleen om verbinding; het is een interne hub waar belangrijke bedrijfsinformatie, zoals beleidsdocumenten, nieuwsupdates en personeelsgidsen, naadloos worden gedeeld. Het bevordert niet alleen efficiëntie maar ook teamwork, de kern van elke vooruitstrevende onderneming.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/intranet.webp',
                ],
            },
            {
                type: 'text',
                title: 'Samenwerken als nooit van te voren',
                content:
                    "Een modern intranet gaat veel verder dan alleen informatie delen. Het staat bol van hulpmiddelen voor samenwerking, zoals: gedeelde agenda's, discussie forums, chats en projectmanagement tools. Dit maakt het mogelijk voor teams om samen te werken aan projecten, bestanden te delen en efficiënt te communiceren, ongeacht waar ze zich bevinden. Samen met mogelijkheden voor informele groepsdiscussies en teamactiviteiten versterkt een goed werkend intranet de bedrijfscultuur.",
            },
            {
                type: 'text',
                title: 'Voordelen van ons klantportaal',
                content: `
                    23G heeft ruime ervaring met het bouwen van intranetten voor bedrijven en helpt jou graag met het bouwen en designen van een intranet dat perfect aansluit op de wensen en mogelijkheden van je bedrijf. Eerder bouwden we bijvoorbeeld een bekroond intranet voor het Erasmus MC waarbij we gebruik maakten van onze eigen WordPress SDK, een combinatie van Headless WordPress en Laravel. Het was niet alleen technisch superieur, maar bood ook een ongeëvenaarde backend UI-ervaring op het gebied van snelheid, schaalbaarheid en veiligheid.
                    <br><br>
                    Voor de developers en designers van 23G is geen vraag te uitdagend of een idee te groot. Wij denken graag met je mee.
                `,
            },
            {
                type: 'case',
                case: 'erasmus_mc',
            },
        ],
        related_services: ['client-portal', 'front-end-development', 'api'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
